/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Download
 */
export interface Download {
    /**
     * 
     * @type {number}
     * @memberof Download
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof Download
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Download
     */
    iconPath?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Download
     */
    faIcon?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Download
     */
    path: string;
}

export function DownloadFromJSON(json: any): Download {
    return DownloadFromJSONTyped(json, false);
}

export function DownloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): Download {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'iconPath': !exists(json, 'icon_path') ? undefined : json['icon_path'],
        'faIcon': !exists(json, 'fa_icon') ? undefined : json['fa_icon'],
        'path': json['path'],
    };
}

export function DownloadToJSON(value?: Download | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'icon_path': value.iconPath,
        'fa_icon': value.faIcon,
        'path': value.path,
    };
}


